import { useFieldArray, useForm } from 'react-hook-form';
import { IProduct, IProductVariation } from 'src/interfaces';

export const useAddProductPage = () => {
  const formMethod = useForm<IProduct & { asset?: File }>({
    mode: 'onSubmit',
    defaultValues: {
      active: true,
      productVariations: [
        {
          active: true,
          nutrition: '000',
          volume: 0,
        } as IProductVariation,
      ],
    } as IProduct,
  });

  const fieldArray = useFieldArray({
    name: 'productVariations',
    control: formMethod.control,
    keyName: 'uid',
  });

  return {
    formMethod,
    fieldArray,
  };
};
